import React, { useState, useRef, useCallback, useEffect } from 'react';
import classNames from 'classnames/bind';
import { ContentCopyIcon, CheckIcon } from 'tuui';
import copyToClipboard from '../../../../modules/campaigns/services/utils/clipboard';
import styles from './DropdownCopyId.module.scss';

const classNameBuilder = classNames.bind(styles);
const CHECK_ICON_DURATION = 2000;
export const DropdownCopyId = ({ label = 'ID', value, checkIconDuration = CHECK_ICON_DURATION, className }) => {
    const [copied, setCopied] = useState(false);
    const timeoutRef = useRef(null);
    const handleCopyClick = useCallback(
        e => {
            e.stopPropagation();
            e.preventDefault();

            copyToClipboard(value)
                .then(() => {
                    setCopied(true);
                    timeoutRef.current = setTimeout(() => setCopied(false), checkIconDuration);
                })
                .catch(err => console.error('Failed to copy text:', err));
        },
        [value, checkIconDuration]
    );

    useEffect(() => {
        return () => clearTimeout(timeoutRef.current);
    }, []);

    return (
        <div
            className={classNameBuilder('container', className, { copied })}
            style={{ '--check-icon-duration': `${checkIconDuration}ms` }}
        >
            <span>
                {label}: {value}
            </span>
            {copied ? (
                <CheckIcon aria-label="Copied!" className={classNameBuilder('icon-check')} />
            ) : (
                <ContentCopyIcon
                    aria-label="Copy ID"
                    onClick={handleCopyClick}
                    className={classNameBuilder('icon-copy')}
                />
            )}
        </div>
    );
};
